<template>
  <section>
    <TableForPage
      style="margin-bottom: 0;"
      :tableData="getUsers"
      :fields="fieldsUsers2"
      :slots="userSlots"
      :isComment="true"
      :modal-text-editor="true"
      @update="updateTable"
    >
      <template v-slot:filtersSelect>
        <div class="some-select ml-3">
          <multiselect
            v-model="employmentType"
            :options="employmentSelect"
            :placeholder="'Select'"
            :track-by="'value'"
            :label="'label'"
            :allow-empty="false"
            :showLabels="false"
          />
        </div>
        <div class="some-select ml-3">
          <multiselect
            v-model="paymentType"
            :options="paymentSelect"
            :placeholder="'Select'"
            :track-by="'value'"
            :label="'label'"
            :allow-empty="false"
            :showLabels="false"
          />
        </div>
      </template>
      <template v-slot:name="slotProps">
        <TableUserItem
          :user="slotProps.item"
          :number="getNumber(slotProps.index)"
        />
      </template>
      <template v-slot:showOnProfileWidget="slotProps">
        <b-button
            variant="secondary"
            class="button btn-icon button-checkbox_sm"
          >
            <b-form-checkbox
              size="sm"
              switch
              v-model="slotProps.item.show_on_widget"
              class="switch"
              @click.native="switchShowOnProfilesWidget(slotProps.item)"
            />
          </b-button>
      </template>
      <template v-slot:isContactPerson="slotProps">
        <b-button
          variant="secondary"
          class="button btn-icon button-checkbox_sm"
          :disabled="slotProps.item.type === 'user-profile'"
        >
          <b-form-checkbox
            size="sm"
            switch
            v-model="slotProps.item.is_contact_person"
            class="switch"
            :disabled="slotProps.item.type === 'user-profile'"
            @click.native="switchContactPersonStatus(slotProps.item)"
          />
        </b-button>
      </template>
      <template v-slot:roles="slotProps">
        <template v-if="!slotProps.item.roleName"
          >Without role</template
        >
        <template v-else>
          <span v-for="(role, index) in slotProps.item.roles" :key="index"
            ><template v-if="index"
              >, </template
            >{{ role.display_name }}</span
          >
        </template>
      </template>
      <template v-slot:skills="slotProps">
        <div class="user-skills__list p-0">
          <div
            class="user-skills__item"
            v-for="skill in slotProps.item.skills"
            :key="skill.id"
          >
            <div class="user-skills-chips">
              {{ skill.name }} {{ skill.value }}
            </div>
          </div>
        </div>
      </template>
      <template v-slot:comment="slotProps">
        <div class="user-comment__list p-0">
          <TextEditor
            :show-text="true"
            data-already-loaded
            :entity-type="commentEntityTypes.UserListComment"
            :entity-id="slotProps.item.id"
          />
        </div>
      </template>
      <template v-slot:action="slotProps" v-if="$can('update_all-users')">
        <div class="d-flex">
          <b-button
            v-if="slotProps.item.status === 'approved'"
            variant="secondary"
            class="button btn-icon button-checkbox_sm"
          >
            <b-form-checkbox
              size="sm"
              switch
              v-model="slotProps.item.userStatus"
              disabled
              class="switch"
              @click.native="
                changeUserStatus(!slotProps.item.userStatus, slotProps.item)
              "
            />
          </b-button>
          <div
            v-else
            v-b-tooltip.hover="{ variant: 'base' }"
            title="This user not approved"
          >
            Not approved
          </div>
          <b-dropdown
            class="dropdown__theme-light navbar__dropdown table__dropdown"
            right
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template v-slot:button-content>
              <span class="material-icons icon-image-preview">
                more_vert
              </span>
            </template>
            <b-dropdown-item-button>
              <router-link
                :to="{ name: 'profile', params: { id: slotProps.item.id, type: slotProps.item.type } }"
              >
                <span class="dropdown-item-link">
                  Edit
                </span>
              </router-link>
            </b-dropdown-item-button>
            <b-dropdown-item-button
              v-if="slotProps.item.type === 'user-profile' && $can('delete-users')"
              @click.prevent="deleteProfile($event, slotProps.item)"
            >
              <span class="dropdown-item-link">
                Delete
              </span>
            </b-dropdown-item-button>
            <b-dropdown-item-button
              v-if="slotProps.item.status === 'pending' && $can('create-users')"
              @click.prevent="approveUser(slotProps.item)"
            >
              <span class="dropdown-item-link">
                Approve
              </span>
            </b-dropdown-item-button>
            <b-dropdown-item-button
              v-if="slotProps.item.status === 'pending' && $can('delete-users')"
              @click.prevent="rejectUser($event, slotProps.item)"
            >
              <span class="dropdown-item-link">
                Reject
              </span>
            </b-dropdown-item-button>
          </b-dropdown>
        </div>
      </template>
    </TableForPage>

    <ModalRestoreUser
      v-model="modalRestoreUser.show"
      :loading="isDataPageLoading"
      @submit="restoreUser"
    />
    <ModalDeleteUser
      v-model="modalDeletedUser.show"
      :loading="isDataPageLoading"
      @submit="deletedUser"
    />
  </section>
</template>

<script>
import { commentEntityTypes } from '@mocks/comment-entity-types'
import ModalRestoreUser from '@components/modals/ModalRestoreUser'
import ModalDeleteUser from '@components/modals/ModalDeleteUser'
import TableForPage from '@tables/TableForPage'
import TableUserItem from '@components/tables/TableUserItem'
import TextEditor from '@components/TextEditor'
import { mapActions } from 'vuex'

export default {
  name: 'DataUsers',
  components: {
    ModalRestoreUser,
    ModalDeleteUser,
    TableForPage,
    TableUserItem,
    TextEditor
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    fieldsUserSkills: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    getAllUsers () {
      if (!this.users.length) return []

      return this.users.map((item, index) => {
        return {
          index,
          ...item,
          show_on_widget: item.show_on_widget === 1 || item.show_on_widget === true,
          is_contact_person: item.is_contact_person === 1 || item.is_contact_person === true,
          userStatus: !item.deleted_at && !item.exit_at && item.status === 'approved'
        }
      })
    },
    filterByEmploymentType () {
      let currentUsers = this.getAllUsers

      if (this.employmentType && this.employmentType.value !== 'all') {
        const currentEmploymentType = this.employmentType.value
        currentUsers = currentUsers.filter(user => user.employment_type.type === currentEmploymentType)
      }

      return currentUsers
    },
    filterByPaymentType () {
      let currentUsers = this.filterByEmploymentType

      if (this.paymentType && this.paymentType.value !== 'all') {
        const currentPaymentType = this.paymentType.value
        currentUsers = currentUsers.filter(user => user.payment_type === currentPaymentType)
      }
      return currentUsers || {}
    },
    getUsers () {
      return this.filterByPaymentType || {}
    },
    commentEntityTypes () {
      return commentEntityTypes
    }
  },
  data () {
    return {
      currentPage: 1,
      perPage: 15,
      modalRestoreUser: {
        show: false,
        user: null
      },
      modalDeletedUser: {
        show: false,
        user: null
      },
      isDataPageLoading: false,
      isWidgetStatusUpdates: false,
      isContactPersonStatusUpdates: false,

      showTd: true,

      fieldsUsers: [
        // {
        //   label: '#'
        // },
        {
          label: 'Avatar'
        },
        {
          label: 'Name'
        },
        {
          label: 'Email'
        },
        {
          label: 'Roles'
        }
      ],
      fieldsUsers2: [
        // {
        //   key: 'index',
        //   label: '#',
        //   class: 'column-number',
        //   sortable: true
        // },
        // {
        //   key: "avatar",
        //   label: "Avatar",
        //   class: "column-avatar",
        //   sortable: false
        // },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'showOnProfileWidget',
          label: 'Show in profile widget',
          class: 'profile-widget-toggle'
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          key: 'isContactPerson',
          label: 'Contact Person',
          class: 'profile-widget-toggle'
        },
        {
          key: 'roles',
          label: 'Roles',
          sortable: true
        },
        {
          key: 'skills',
          label: 'Skills',
          sortable: true
        },
        {
          key: 'comment',
          label: 'Comment'
        },
        {
          key: 'action',
          label: 'Actions',
          class: 'column-controls-md'
        }
      ],
      userSlots: {
        index: {
          name: 'index',
          comment: false
        },
        name: {
          name: 'name',
          comment: false
        },
        avatar: {
          name: 'avatar',
          comment: false
        },
        showOnProfileWidget: {
          name: 'showOnProfileWidget',
          comment: false,
          class: 'profile-widget-toggle'
        },
        isContactPerson: {
          name: 'isContactPerson',
          comment: false,
          class: 'profile-widget-toggle'
        },
        roles: {
          name: 'roles',
          comment: false
        },
        skills: {
          name: 'skills',
          comment: false
        },
        comment: {
          name: 'comment',
          comment: false
        },
        action: {
          name: 'action',
          comment: false
        }
      },
      employmentSelect: [
        { value: 'all', label: 'All empl. types' },
        { value: 'team_member', label: 'Team member' },
        { value: 'independent', label: 'Independent' },
        { value: 'partner', label: 'Partner' }
      ],
      paymentSelect: [
        { value: 'all', label: 'All pay. types' },
        { value: 'monthly', label: 'Monthly' },
        { value: 'hourly', label: 'Hourly' }
      ],
      employmentType: { value: 'all', label: 'All empl. types' },
      paymentType: { value: 'all', label: 'All pay. types' },
      showEditor: false,
      commentEditorOptions: {
        entity_type: commentEntityTypes.UserListComment,
        data_already_loaded: true
      }
    }
  },
  async mounted () {
    await this.fetchComments({ type: commentEntityTypes.UserListComment })
  },
  methods: {
    ...mapActions({
      fetchComments: 'comments/fetchComments'
    }),
    changeUserStatus (data, user) {
      data ? this.showModalRestoreUser(user) : this.showModalDeletedUser(user)
    },
    switchShowOnProfilesWidget (user) {
      if (!this.isWidgetStatusUpdates) {
        this.isWidgetStatusUpdates = true
        const isShow = !user.show_on_widget || false

        this.axios.put(
          `/api/users/${user.id}/show-on-profiles-widget`,
          {
            userType: user.type,
            showOnWidgetStatus: isShow ? 1 : 0
          },
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }).then(response => {
          if (response.status === 200) {
            this.$snotify.success('Show on Profiles Widget ' + (isShow ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
          }
        }).catch(err => {
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
          }
        }).finally(() => {
          this.isWidgetStatusUpdates = false
        })
      }
    },
    switchContactPersonStatus (user) {
      if (!this.isContactPersonStatusUpdates && user.type !== 'user-profile') {
        this.isContactPersonStatusUpdates = true
        const isContactPerson = !user.is_contact_person || false

        this.axios.put(
          `/api/users/${user.id}/contact-person`,
          {
            isContactPerson: isContactPerson ? 1 : 0
          },
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }).then(response => {
          if (response.status === 200) {
            this.$snotify.success('Contact Person ' + (isContactPerson ? 'On' : 'Off'), 'Success', this.$store.state.snotify)
          }
        }).catch(err => {
          const errors = Object.values(err.response.data.errors)
          for (let i = 0; i < errors.length; i++) {
            this.$snotify.error(errors[i][0], 'Error', this.$store.state.snotify)
          }
        }).finally(() => {
          this.isContactPersonStatusUpdates = false
        })
      }
    },
    addItem: function () {
      var formSearch = document.querySelector('.plus-code').innerHTML
      var elemPush = document.querySelector('.formSearch')
      elemPush.innerHTML += '<div>' + formSearch + '</div>'
    },
    showStatuses (e) {
      e.target.parentElement
        .getElementsByClassName('hide-statuses')[0]
        .classList.remove('d-none')
      this.showTd = false
      e.target.classList.add('d-none')
    },
    hideStatuses (e) {
      e.target.parentElement
        .getElementsByClassName('show-statuses')[0]
        .classList.remove('d-none')
      this.showTd = true
      e.target.classList.add('d-none')
    },
    approveUser (user) {
      this.axios({
        method: 'put',
        url: `/api/pending/user/${user.id}/append`,
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
        .then(response => {
          user.status = 'approved'
          user.userStatus = !user.deleted_at && !user.exit_at
        })
        .catch(err => {
          console.log(err)
          this.$snotify.error(
            err.response.data.message,
            'Error',
            this.$store.state.snotify
          )
        })
    },

    rejectUser (e, user) {
      this.axios({
        method: 'delete',
        url: `/api/pending/user/${user.id}/reject`,
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
        .then(response => {
          e.target.parentElement.parentElement.remove()
        })
        .catch(err => {
          console.log(err)
          this.$snotify.error(
            err.response.data.message,
            'Error',
            this.$store.state.snotify
          )
        })
    },

    async deleteProfile (e, user) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete profile?'
      )

      if (!confirm) return
      this.axios({
        method: 'delete',
        url: `/api/users/profiles/${user.id}`,
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
        .then(response => {
          if (response.status === 200) {
            this.$snotify.success('Profile successfully deleted.', 'Success', this.$store.state.snotify)
          }
          let profileRow = document.querySelector(`[data-pk="${user.id}"]`)
          if (profileRow) {
            profileRow.remove()
          }
        })
        .catch(err => {
          console.log(err)
          this.$snotify.error(
            err.response.data.message,
            'Error',
            this.$store.state.snotify
          )
        })
    },

    deletedUser (data) {
      // eslint-disable-next-line camelcase
      const date_exit = this._toLocalTime(data.date.value)

      this._toggleDataPageLoading(() => {
        return this.$api.users
          .deleteUser(this.modalDeletedUser.user.id, { date_exit })
          .then(response => {
            this.modalDeletedUser.user.deleted_at = response.deleted_at
            this.modalDeletedUser.user.exit_at = response.exit_at
            this.$emit('updateUser')
          })
          .catch(err => {
            console.log(err)
            this.$snotify.error(
              err.response.data.message,
              'Error',
              this.$store.state.snotify
            )
          })
          .finally(() => {
            this.hideModalDeletedUser()
          })
      })
    },
    showModalRestoreUser (user) {
      this.modalRestoreUser.show = true
      this.modalRestoreUser.user = user
    },
    hideRestoreUser () {
      this.modalRestoreUser.show = false
      this.modalRestoreUser.user = null
    },
    showModalDeletedUser (user) {
      this.modalDeletedUser.show = true
      this.modalDeletedUser.user = user
    },
    hideModalDeletedUser () {
      this.modalDeletedUser.show = false
      this.modalDeletedUser.user = null
    },
    restoreUser (data) {
      // eslint-disable-next-line camelcase
      const date_start = this._toLocalTime(data.date.value)

      this._toggleDataPageLoading(() => {
        return this.$api.users
          .restoreUser(this.modalRestoreUser.user.id, { date_start })
          .then(res => {
            this.modalRestoreUser.user.deleted_at = res.deleted_at
            this.modalRestoreUser.user.exit_at = res.exit_at
            this.$emit('updateUser')
          })
          .catch(err => {
            this.$snotify.error(
              err.response.data.message,
              'Error',
              this.$store.state.snotify
            )
          })
          .finally(() => {
            this.hideRestoreUser()
          })
      })
    },
    updateTable (data) {
      this.currentPage = data.currentPage
      this.perPage = data.perPage
    },
    getNumber (index) {
      if (this.currentPage > 1) {
        const curPage = this.currentPage - 1
        return (this.perPage * curPage) + index
      } else {
        return index
      }
    }
  }
}
</script>

<style scoped>
.users-item img {
  margin-right: 15px;
  width: 45px;
  height: 45px;
}

.users-item-data p span {
  font-weight: 600;
}

.some-select {
  width: 140px;
  margin-bottom: 1rem;
}

</style>
